import React from 'react';
import PropTypes from 'prop-types';

import './spinner.css';

const getSizeClass = (small, medium, big) => {
  if (big) return 'lds-big';
  if (medium) return 'lds-medium';
  if (small) return 'lds-small';
  return 'lds-medium';
};

const isWhite = (white) => {
  if (white) return 'white';
};

// If no size prop is given, this will assume medium.
const Spinner = (props) => {
  const { big, medium, small, noPadding, white = false } = props;
  return <div className={`lds-dual-ring ${isWhite(white)} ${getSizeClass(small, medium, big)} ${noPadding ? 'no-padding' : ''}`} />;
};

if (process.env.NODE_ENV !== 'production') {
  Spinner.propTypes = {
    big: PropTypes.bool,
    medium: PropTypes.bool,
    small: PropTypes.bool,
    noPadding: PropTypes.bool
  };
}

Spinner.defaultProps = {
  noPadding: false
};

export default Spinner;
